<div class="row space-between">
  <h2>Edit Step</h2>
  <rr-icon class="pointer" name="close" (click)="close()"></rr-icon>
</div>
<div class="row gap-8 align-end">
  <rr-select
    label="Pattern"
    class="grow-1"
    [options]="stepTypes"
    [preselectedValue]="step?.stepTypeId"
    [formControl]="stepTypeFormControl"
    optionName="name"
    optionValue="id"
  ></rr-select>
  <rr-input
    label="Credits"
    class="creditcosts"
    type="number"
    [formControl]="formControlCreditCosts"
  ></rr-input>
</div>
<rr-select
  label="Version"
  class="versionselect"
  [options]="stepPromptVersions"
  [formControl]="stepVersionFormControl"
  [preselectedValue]="stepVersionFormControl?.value || 0"
  optionName="name"
  optionValue="id"
></rr-select>
<mat-accordion displayMode="default" [multi]="false" [hideToggle]="false">
  <mat-expansion-panel [hideToggle]="false">
    <mat-expansion-panel-header>RAG Files</mat-expansion-panel-header>
    <app-rag-component label="Step Files" [hubId]="step.id"></app-rag-component>
  </mat-expansion-panel>
  <mat-expansion-panel [hideToggle]="false">
    <mat-expansion-panel-header>Initialize Prompt</mat-expansion-panel-header>

    <textarea [formControl]="initializePrompt?.control"></textarea>
    <rr-select
      [options]="agents"
      optionName="name"
      iconType="image"
      optionValue="id"
      [preselectedValue]="initializePrompt?.agentControl?.value"
      [control]="initializePrompt?.agentControl"
    ></rr-select>
  </mat-expansion-panel>
  <mat-expansion-panel [hideToggle]="false">
    <mat-expansion-panel-header>Fill Out All Prompt</mat-expansion-panel-header>
    <textarea [formControl]="fillOutAllPrompt?.control"></textarea>
    <rr-select
      [options]="agents"
      optionName="name"
      iconType="image"
      optionValue="id"
      [preselectedValue]="fillOutAllPrompt?.agentControl?.value"
      [control]="fillOutAllPrompt?.agentControl"
    ></rr-select>
  </mat-expansion-panel>
  <mat-expansion-panel [hideToggle]="false">
    <mat-expansion-panel-header>Step Prompt</mat-expansion-panel-header>
    <div class="col gap-24 w100">
      @for(prompt of stepPrompts; track prompt){
      <div class="col w100 gap-8">
        <textarea [formControl]="prompt.control"></textarea>
        <rr-select
          [options]="agents"
          optionName="name"
          iconType="image"
          optionValue="id"
          [preselectedValue]="prompt.agentControl?.value"
          [control]="prompt.agentControl"
        ></rr-select>
      </div>
      }
    </div>
    <mat-action-row>
      <rr-btn
        type="Secondary"
        iconStart="add"
        (click)="addPrompt('STEP_PROMPT')"
        >Add Prompt</rr-btn
      >
    </mat-action-row>
  </mat-expansion-panel>
  <mat-expansion-panel [hideToggle]="false">
    <mat-expansion-panel-header>Closing</mat-expansion-panel-header>
    @for(prompt of closingPrompts; track prompt){
    <textarea [formControl]="prompt.control"></textarea>
    <rr-select
      [options]="agents"
      optionName="name"
      iconType="image"
      optionValue="id"
      [preselectedValue]="prompt.agentControl?.value"
      [control]="prompt.agentControl"
    ></rr-select>
    }
    <mat-action-row>
      <rr-btn
        type="Secondary"
        iconStart="add"
        (click)="addPrompt('CLOSING_STEP_PROMPT')"
        >Add Prompt</rr-btn
      >
    </mat-action-row>
  </mat-expansion-panel>
</mat-accordion>
<div class="row gap-8 align-center justify-end space-between w100 actionrow">
  <div class="row gap-8">
    <rr-btn
      type="Secondary"
      size="medium"
      iconStart="ai"
      (click)="openTestStep()"
      >Test</rr-btn
    >
    <rr-btn
      type="Primary"
      size="medium"
      iconStart="save"
      (click)="savePrompts()"
      >Save</rr-btn
    >
  </div>
</div>
